import { render, staticRenderFns } from "./select-sort-options.vue?vue&type=template&id=63e9baaf&scoped=true&lang=pug&"
import script from "./select-sort-options.vue?vue&type=script&lang=ts&"
export * from "./select-sort-options.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9baaf",
  null
  
)

export default component.exports